import { graphql } from '~/lib/graphql'

export const RestaurantInventoryCourse = graphql(`
  fragment RestaurantInventoryCourse on RestaurantInventoryCourse {
    course {
      ...CourseSelectionInfo
    }
    plans {
      plan {
        ...PlanSelectionInfo
        ...PlanAttributes
      }
      seats {
        ...SeatAttributes
      }
      price
      discountRatePercent
      pointRatePercent
      fixedPoints
    }
  }
`)
